import { render, staticRenderFns } from "./AffirmBookseller.vue?vue&type=template&id=8e9fd4ee&"
import script from "./AffirmBookseller.vue?vue&type=script&lang=js&"
export * from "./AffirmBookseller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports